import React from "react";

import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text";

import {IBreadcrumb} from "./IBreadcrumb";
import {SeparatorIcon} from "./SeparatorIcon";

interface IProps extends IBreadcrumb {
    className?: string;
    separatorIcon?: React.JSX.Element;
    isLinkingToCurrentLocation?: boolean;
}

export const BreadcrumbsItem = (props: IProps) => {
    const {name, url, isLinkingToCurrentLocation, className, separatorIcon} = props;

    return (
        <li className={className}>
            {isLinkingToCurrentLocation ? (
                <Text variant="info_txt_1" as="span">
                    <span>{name}</span>
                </Text>
            ) : (
                <Link size="small" href={url} target="_self">
                    <span>{name}</span>
                </Link>
            )}

            {separatorIcon || <SeparatorIcon />}
        </li>
    );
};
import React from "react";

import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text";

import {IBreadcrumb} from "./IBreadcrumb";
import {SeparatorIcon} from "./SeparatorIcon";

interface IProps extends IBreadcrumb {
    className?: string;
    separatorIcon?: React.JSX.Element;
    isLinkingToCurrentLocation?: boolean;
}

export const BreadcrumbsItem = (props: IProps) => {
    const {name, url, isLinkingToCurrentLocation, className, separatorIcon} = props;

    return (
        <li className={className}>
            {isLinkingToCurrentLocation ? (
                <Text variant="info_txt_1" as="span">
                    <span>{name}</span>
                </Text>
            ) : (
                <Link size="small" href={url} target="_self">
                    <span>{name}</span>
                </Link>
            )}

            {separatorIcon || <SeparatorIcon />}
        </li>
    );
};
